var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "h2 mb-2" }, [
      _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm._l(_vm.zoneOffers.zoneOffersItem, function (zoneOffersItem, index) {
          return [
            _c(
              "div",
              {
                key: index,
                staticClass: "col-12 col-md-6",
                class: index > 0 ? "mt-1 mt-md-0" : "",
              },
              [
                _c(
                  "ob1-cards",
                  {
                    staticClass: "d-flex flex-column h-100 border-0",
                    attrs: { "is-multiple": true, "with-composite-link": true },
                  },
                  [
                    _c("img", {
                      staticClass: "w-100",
                      attrs: {
                        src: zoneOffersItem.image.src,
                        alt: zoneOffersItem.image.alt,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "px-1 px-md-2 d-flex flex-column flex-grow-1 bg-white",
                      },
                      [
                        _c(
                          "h3",
                          { staticClass: "text-primary mt-1 pb-0 mb-0" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(zoneOffersItem.title) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "lead mb-1" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(zoneOffersItem.text) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ob1-boutons", {
                          staticClass:
                            "mb-2 mt-auto align-self-center align-self-md-start",
                          attrs: {
                            "is-secondary": true,
                            "is-button": false,
                            label: zoneOffersItem.labelButton,
                            href: zoneOffersItem.urlButton,
                            "data-oevent-category": zoneOffersItem.tms.tagZone,
                            "data-oevent-action": zoneOffersItem.tms.tagName,
                            "data-oevent-label": zoneOffersItem.urlButton,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }